module.exports = __webpack_public_path__ + "static/media/googlelogo.44abadbb.svg";